import * as React from 'react';
import { Link } from 'react-router';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';
import { compose } from 'underscore';

import connectToRouter from 'js/lib/connectToRouter';
import mapProps from 'js/lib/mapProps';
import path from 'js/lib/path';

import discussionsForumsHOC from 'bundles/discussions/components/discussionsForumsHOC';
import routerConnectToCurrentForum from 'bundles/discussions/utils/routerConnectToCurrentForum';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import GroupForumsV1 from 'bundles/naptimejs/resources/groupForums.v1';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import OnDemandCourseForumsV1 from 'bundles/naptimejs/resources/onDemandCourseForums.v1';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import OnDemandMentorForumsV1 from 'bundles/naptimejs/resources/onDemandMentorForums.v1';

class NextViewLink extends React.Component {
  static propTypes = {
    question: PropTypes.object.isRequired,
    questionForum: PropTypes.oneOfType([
      PropTypes.instanceOf(OnDemandCourseForumsV1),
      PropTypes.instanceOf(OnDemandMentorForumsV1),
      PropTypes.instanceOf(GroupForumsV1),
    ]),

    rootPath: PropTypes.string,
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
  };

  declare context: LegacyContextType<typeof NextViewLink.contextTypes>;

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'questionForum' does not exist on type 'R... Remove this comment to see the full error message
    if (!this.props.questionForum) {
      return null;
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'rootPath' does not exist on type 'Readon... Remove this comment to see the full error message
    const link = path.join(this.props.rootPath, this.props.questionForum.link);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'questionForum' does not exist on type 'R... Remove this comment to see the full error message
    const title = this.props.questionForum.title;

    if (!link || !title) return null;
    return (
      <span className="rc-NextViewName">
        <Link to={link} className="caption-text">
          {title}
        </Link>
      </span>
    );
  }
}

export default compose(
  discussionsForumsHOC({ fields: ['link', 'title'] }),
  connectToRouter(routerConnectToCurrentForum),
  mapProps((props) => {
    // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
    const questionForumId = props.question.forumId;
    return {
      questionForum:
        // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
        props.courseForums.concat(props.mentorForums) &&
        // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
        props.courseForums.find((forum) => forum.forumId === questionForumId),
    };
  })
)(NextViewLink);
